import React from "react";
import { Spinner, Image } from "react-bootstrap";

export const MyButton = ({
  text,
  disabled,
  isLoading,
  className,
  loaderWidth,
  handleClick,
  loaderHeight,
  loaderClassName,
  iconButtonImage,
  arrowIcon,
  ...props
}) => {
  return (
    <>
      <button
        className={className}
        disabled={disabled || isLoading}
        style={{
          pointerEvents: disabled || isLoading ? "none" : "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          opacity: disabled ? 0.6 : 1,
        }}
        onClick={handleClick && handleClick}
        {...props}
      >
        {isLoading ? (
          <Spinner
            role="status"
            animation="border"
            className={loaderClassName}
            style={{
              width: loaderWidth ?? "1.5rem",
              height: loaderHeight ?? "1.5rem",
            }}
          />
        ) : (
          <>
            {iconButtonImage && (
              <Image src={iconButtonImage} className="btnIcon" />
            )}
            {text}
            {arrowIcon && <Image src={arrowIcon} className="arrowIcon" />}
          </>
        )}
      </button>
    </>
  );
};
